/*
 * Keeps the discount % badge (.sale_percent[data-sale-percent], rendered by snippets/price-list.liquid) correct.
 * Main product pages and the sticky bar are handled by the inline script in price-list.liquid; this global file covers
 * quick-buy modals, whose markup is inserted through DOMParser, where inline scripts may not run.
 *
 * The % is derived from the sibling <sale-price> / <compare-at-price> (kept current by theme.js) rather than from the
 * variant:change payload, and it also runs once on load, so a late-loading file self-heals instead of staying stale.
 */
(function () {
  function amount(el) {
    // Locale-aware: the last separator is a decimal mark only when followed by 1-2 digits ("1.299,00", "1,50");
    // otherwise every separator is a thousands mark ("5,590", "1.299", "1 000", "1'000").
    var m = el.textContent.match(/\d[\d.,\s\u00a0\u202f'\u2019]*\d|\d/);
    if (!m) return 0;
    var s = m[0].replace(/[\s\u00a0\u202f'\u2019]/g, "");
    var i = Math.max(s.lastIndexOf("."), s.lastIndexOf(","));
    if (i > -1 && s.length - i - 1 <= 2) {
      return parseFloat(s.slice(0, i).replace(/[.,]/g, "") + "." + s.slice(i + 1));
    }
    return parseFloat(s.replace(/[.,]/g, ""));
  }

  function sync(badge) {
    var list = badge.closest("price-list");
    var sale = list && list.querySelector("sale-price");
    var compare = list && list.querySelector("compare-at-price");
    if (!sale || !compare) return;
    var price = amount(sale);
    var was = amount(compare);
    var onSale = !compare.hidden && was > price && price >= 0;
    badge.hidden = !onSale;
    badge.textContent = onSale ? Math.round(((was - price) * 100) / was) + "%" : "";
  }

  function syncAll() {
    document.querySelectorAll("[data-sale-percent]").forEach(sync);
  }

  // theme.js updates the prices in listeners on the form, which run before this document-level (bubbling) listener.
  document.addEventListener("variant:change", syncAll);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncAll);
  } else {
    syncAll();
  }
})();
